<main
    *ngIf="briefing"
    class="agpr-briefingReport"
    [agprLoading]="briefingLoading || reportLoading"
    #overlayContainer
>
    @if (briefing.deliveryMethod === briefingDeliveryMethodEnum.ONLINE) {
        <section
            class="agpr-briefingReport-center"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <div class="agpr-briefingReport-center-content">
                <h2 class="agpr-briefingReport-name">
                    <span>{{ briefing.name }}</span>&nbsp;
                    <span class="u-srOnly">{{ 'Monitor.primaryHeading.briefingReport' | localize }}</span>
                </h2>
                <div class="agpr-briefingReport-center-canvasUrl">
                    @if (canvasUrl) {
                        <div class="agpr-briefingReport-header">
                            {{ 'Briefing.report.canvasUrl' | localize }}
                        </div>
                        <div class="agpr-briefingReport-canvasUrl">
                            <a
                                class="agpr-briefingReport-canvasUrl-link"
                                [href]="canvasUrl"
                                target="_blank"
                            >
                                {{ canvasUrl }}
                            </a>

                            <agpr-button
                                class="agpr-briefingReport-canvasUrl-urlCopyIcon"
                                [style]="buttonTypes.icon"
                                icon="fa-kit-duotone fa-agpr-copy"
                                tooltip="Reports.sharedReports.rhp.copyUrl"
                                tooltipPosition="top"
                                (click)="copyUrl($event, canvasUrl)"
                            ></agpr-button>
                        </div>

                        <div class="agpr-briefingReport-center-digest">
                            <div class="agpr-briefingReport-header">
                                {{ 'Briefing.report.digest' | localize }}
                            </div>
                            <agpr-digest-picker
                                [id]="'digestPicker'"
                                [(ngModel)]="briefing.digests"
                                (ngModelChange)="digestChange()"
                            ></agpr-digest-picker>
                        </div>

                        @if (iframeUrl) {
                            <div class="agpr-briefingReport-pdfIframe">
                                <iframe
                                    id="briefing_pdf_iframe"
                                    width="1110px"
                                    height="100%"
                                    allowfullscreen
                                    [src]="iframeUrl"
                                    frameborder="0"
                                    sandbox="allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox allow-scripts allow-downloads allow-forms allow-modals"
                                    scrolling="no"
                                >
                                </iframe>
                            </div>
                        }
                    } @else {
                        <div class="agpr-briefingReport-placeholder">
                            <div class="agpr-briefingReport-placeholder-mainContainer">
                                <span class="fa-duotone fa-regular fa-chart-line-up noContentIcon"
                                    aria-hidden="true"
                                ></span>
                                <div>
                                    <div class="mainText">
                                        {{"Briefing.report.canvasUrl.noContentPlaceholderHeading"| localize}}
                                    </div>
                                    <div class="subText">
                                        {{"Briefing.report.canvasUrl.noContentPlaceholderInfo"| localize}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <agpr-action-bar>
                <ng-template #right>
                    @if (
                        isScheduled
                        && (
                            briefing?.sendAt?.sendNow === false
                            || briefing?.sendAt?.sendNow === null
                        )
                    ) {
                        <agpr-button
                            [id]="id + '.briefingCancelScheduledBriefingButton'"
                            label="Briefing.cancelButtonLabel"
                            (click)="cancel()"
                        ></agpr-button>
                    }
                </ng-template>
            </agpr-action-bar>
        </section>
    } @else {
        <section
            class="agpr-briefingReport-center"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <div class="agpr-briefingReport-center-toolbar">
                <h2 class="agpr-briefingReport-name">
                    <span>{{ briefing.name }}</span>&nbsp;
                    <span class="u-srOnly">{{ 'Monitor.primaryHeading.briefingReport' | localize }}</span>
                </h2>


                <agpr-tabs
                    class="agpr-briefingReportTabs"
                    [selectedTabIndex]="selectedTabIndex"
                    (selectedTabIndexChange)="tabChange($event)"
                >
                    <agpr-tab
                        [icon]="'fa-regular fa-duotone fa-gauge-simple-high'"
                        [heading]="'Briefing.report.type.performance'"
                        [id]="'briefingReport.performanceTab'"
                    >
                    </agpr-tab>
                    <agpr-tab
                        [icon]="'fa-regular fa-duotone fa-envelope'"
                        [heading]="'Briefing.report.type.recipient'"
                        [id]="'briefingReport.recipientTab'"
                    >
                    </agpr-tab>
                    <agpr-tab
                        [icon]="'fa-kit fa-agpr-compose'"
                        [heading]="'Briefing.report.type.composition'"
                        [id]="'briefingReport.compositionTab'"
                    >
                    </agpr-tab>
                </agpr-tabs>
            </div>
            <agpr-scroll-panel #scrollPanel>
                <div class="agpr-briefingReport-center-report">
                    <agpr-performance-report
                        *ngIf="selectedTabIndex === statisticsReportType.performance"
                        [sentDate]="sentDateValue"
                        [status]="briefing.status"
                        [isScheduled]="isScheduled"
                        [statisticReportSourceType]="statisticReportSourceType.BRIEFING"
                        [isRSSFeed]="isRSSFeed"
                        [placeholderTitle]="'Briefings.sentReport.reportPlaceholder.sent'"
                        [dataNotAvailable]="dataNotAvailable"
                        [(enableMppEstimates)]="enableMppEstimates"
                        (mppEstimateChanged)="changeMppEstimates($event)"
                        [clickTracking]="briefing.clickTracking"
                        [openTracking]="briefing.openTracking"
                    ></agpr-performance-report>
                    <agpr-recipient-report
                        *ngIf="selectedTabIndex === statisticsReportType.recipients"
                        (statTypeSelected)="statTypeSelected($event)"
                        [sentDate]="sentDateValue"
                        [status]="briefing.status"
                        [isScheduled]="isScheduled"
                        [recipientTotal]="recipientTotal"
                        [dataNotAvailable]="dataNotAvailable"
                        [isRSSFeed]="isRSSFeed"
                        [placeholderTitle]="'Briefings.sentReport.reportPlaceholder.sent'"
                        [(enableMppEstimates)]="enableMppEstimates"
                        (mppEstimateChanged)="changeMppEstimates($event)"
                        [selectedType]="selectedRecipientType"
                        [selectedIndividualRecipient]="selectedIndividualRecipient"
                        [clickTracking]="briefing.clickTracking"
                        [openTracking]="briefing.openTracking"
                    ></agpr-recipient-report>
                    <agpr-email-header
                        *ngIf="selectedTabIndex === statisticsReportType.composition"
                        [subjectLine]="briefing.subject"
                        [fromName]="briefing.fromName"
                        [replyEmail]="briefing.replyTo"
                        [sentDate]="sentDate"
                    ></agpr-email-header>
                    <agpr-composition-report
                        *ngIf="selectedTabIndex === statisticsReportType.composition"
                        [status]="briefing.status"
                        [bodyHtml]="bodyHtml"
                        [isRSSFeed]="isRSSFeed"
                        [bodyPlainText]="bodyPlainText"
                    ></agpr-composition-report>
                </div>
            </agpr-scroll-panel>

            <agpr-action-bar>
                <ng-template #right>
                    @if (
                        isScheduled
                        && (
                            briefing?.sendAt?.sendNow === false
                            || briefing?.sendAt?.sendNow === null
                        )
                    ) {
                        <agpr-button
                            [id]="id + '.briefingCancelScheduledBriefingButton'"
                            label="Briefing.cancelButtonLabel"
                            (click)="cancel()"
                        ></agpr-button>
                    }
                    <agpr-button
                        *ngIf="showExportButton"
                        label="Briefing.report.export"
                        [style]="buttonTypes.primary"
                        (click)="exportReport()"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </section>
    }

    <aside
        class="agpr-briefingReport-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar
            #rhp
            [overlayContainer]="overlayContainer"
            [selectedTabIndex]="selectedRHPTabIndex"
            (selectedTabIndexChange)="selectedRHPTabIndex = $event;"
        >
            @let isCanvas = briefing.deliveryMethod === briefingDeliveryMethodEnum.ONLINE;
            <agpr-email-recipient-search-tab
                [id]="id + 'recipientSearchTab'"
                [icon]="isCanvas ? 'fa-bell' : 'fa-users'"
                [tooltip]="isCanvas ? 'Briefing.publishingNotificationsTab' : 'Briefing.recipientTab'"
                [disabled]="disableRecipientsTab"
                [briefingType]="briefing.deliveryMethod"
            ></agpr-email-recipient-search-tab>

            @if (isCanvas) {
                <agpr-tab
                    [id]="'briefingPdfTab'"
                    icon="fa-file-pdf"
                    [heading]="'Briefing.pdf.generate'"
                    [tooltip]="'Briefing.pdf'"
                >
                    <agpr-message [severity]="messageSeverityEnum.info">
                        {{ 'briefing.pdf.warning' | localize}}
                    </agpr-message>

                    <agpr-checkbox
                        [id]="'briefing.pdf.includeMentions'"
                        class="agpr-checkbox-"
                        [value]="includeMentionsInPDF"
                        [label]="'Briefing.pdf.includeMentions'"
                        [infoCircleTooltip]="'Briefing.pdf.includeMentions.tooltip'"
                        [binary]="true"
                        [(ngModel)]="includeMentionsInPDF"
                    >
                    </agpr-checkbox>

                    <div class="agpr-briefingReport-generatePDF">
                        <agpr-button
                            [id]="id + '.briefingDownloadPDFButton'"
                            label="Briefing.pdf.generate"
                            [disabled]="generatingPDF || !iframeUrl"
                            [loading]="generatingPDF"
                            [tooltip]="!iframeUrl ? 'Briefing.pdf.cannotGenerateUntilSent' : ''"
                            [style]="buttonTypes.tertiary"
                            (click)="generatePDF()"
                        ></agpr-button>
                    </div>
                </agpr-tab>
            }

            <agpr-tab
                [id]="'briefingDetailsTab'"
                icon=" fa-file-lines"
                [showSpacer]="true"
                [tooltip]="isCanvas ? 'Briefing.canvasDetails' : 'Briefing.briefingDetails'"
            >
                <agpr-attribute-list
                    [attributes]="briefingDetails"
                >
                </agpr-attribute-list>
                @if (isCanvas && notificationDetails.length) {
                    <agpr-panel
                        class="agpr-briefing-sideBarSentDetails"
                        header="Briefing.sentCanvasNotificationDetails"
                    >
                        <agpr-attribute-list
                            [attributes]="notificationDetails"
                        ></agpr-attribute-list>
                    </agpr-panel>
                }
                <agpr-panel
                    class="agpr-briefing-sideBarSentDetails"
                    [header]="isCanvas ? 'Briefing.sentCanvasDetails' : 'Briefing.sentBriefingDetails'"
                    *ngIf="sentDetails[0]?.value"
                >
                    <agpr-attribute-list
                        [attributes]="sentDetails"
                    >
                    </agpr-attribute-list>
                </agpr-panel>
                @if (isScheduled) {
                    <ng-container>
                        <agpr-panel
                            class="agpr-briefing-sideBarSentDetails"
                            [header]="isCanvas ? 'Briefing.scheduledCanvasDetails' : 'Briefing.scheduledBriefingDetails'"
                        >
                            <agpr-attribute-list
                                [attributes]="scheduledBriefingDetails"
                            >
                            </agpr-attribute-list>
                        </agpr-panel>
                    </ng-container>
                }
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</main>

<ng-template let-feed let-copyUrl="copyUrl" let-message="message" #rssFeedSentDetails>
    @if (feed) {
        <div class="agpr-briefing-rssFeedSent">
            <p> {{ feed.name }} </p>
            <div class="agpr-briefing-rssFeedSent-linkContainer">
                <span class="fa fa-rss agpr-briefing-rssFeedSent-linkContainer-icon" aria-hidden="true"></span>
                <a class="agpr-briefing-rssFeedSent-linkContainer-link" [href]="feed.url" target="_blank"> {{ feed.url }} </a>
                <agpr-button
                    [style]="buttonTypes.icon"
                    icon="fa-kit-duotone fa-agpr-copy"
                    tooltip="Reports.sharedReports.rhp.copyUrl"
                    tooltipPosition="top"
                    (click)="copyUrl($event, feed.url, message)"
                ></agpr-button>
            </div>
        </div>
    }
</ng-template>
